import { Box, Typography, Button } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

/**
 * Estado vazio honesto: mensagem + (opcional) ação.
 * Substitui o anti-padrão de forjar linhas em branco com Array.from para
 * "completar" a tabela.
 *
 * @param {ReactNode} icon       ícone opcional acima do título
 * @param {string}    title      título curto (ex.: "Nenhum pedido ainda")
 * @param {string}    description texto de apoio opcional
 * @param {string}    actionLabel rótulo do botão (opcional)
 * @param {string}    actionTo    rota do botão (react-router)
 */
export default function EmptyState({ icon, title, description, actionLabel, actionTo }) {
    return (
        <Box sx={{ textAlign: 'center', py: 6, px: 2 }}>
            {icon && (
                <Box sx={{ color: 'text.secondary', fontSize: 40, mb: 1, lineHeight: 1 }}>
                    {icon}
                </Box>
            )}
            <Typography variant="h4" sx={{ color: 'text.primary' }}>
                {title}
            </Typography>
            {description && (
                <Typography variant="body2" sx={{ mt: 1, color: 'text.secondary', maxWidth: 420, mx: 'auto' }}>
                    {description}
                </Typography>
            )}
            {actionLabel && actionTo && (
                <Button
                    component={RouterLink}
                    to={actionTo}
                    variant="contained"
                    color="secondary"
                    sx={{ mt: 3 }}
                >
                    {actionLabel}
                </Button>
            )}
        </Box>
    );
}
